<template>
	<div>
		<pageHead></pageHead>
		<div class="service-main">
			<page-banner :title="'服务内容'" :breadTxt="'机房检测'" :tipTxt="'提供“规范、科学、公正、专业、诚信”的等级保护测评服务'"></page-banner>
			
			<p class="t-align-center serviceT mt-50">机房检测</p>
			<p class="t-align-center serviceT mt-10 mb-20">Computer room inspection</p>
			<div class="m-0auto maxw-1400 pb-50">
				<p class="t-indent2 fz-24 line-26 mb-50">机房是一个承载关键负载的空间，设备一旦投入使用运行就很难停下来进行维护。由于计算机机房环境必须满足计算机等各种微机电子设备和工作人员对温度、湿度、洁净度、电磁场强度、噪音干扰、防漏、电源质量、防雷和接地等条件的要求。所以，一个合格的现代化计算机机房，应该是一个安全可靠、节能高效和有可扩充性的机房。</p>
				<p class="f-blue fz-24 line-50 f-bold">机房设计及工程常见问题</p>
				<div class="li-w">
					<li>温度过高情况下，机房设备长期工作会降低设备寿命。温度过低易产生静电，烧坏机器主板。</li>
					<li>机房噪声超标，影响机房工作人员的正常工作，容易导致听力下降。</li>
					<li>防静电地板、接地等方面处理不好：导致正常情况下产生的静电没有良好的泄放路径，可能引起工作人员的不适、甚至烧毁机器。</li>
					<li>无线电、电磁场干扰太强：可导致其工作异常，影响数据传输质量甚至数据丢失。</li>
				</div>
			</div>
		</div>
		
		<page-foot></page-foot>
	</div>
</template>

<script>
	import pageHead from '../../components/pageHead'
	import pageBanner from '../../components/pageBanner'
	import pageFoot from '../../components/pagefoot'
	export default{
		components:{
			pageHead,
			pageBanner,
			pageFoot
		},
		data(){
			return {
				
			}
		},
		methods:{
			
		}
	}
</script>

<style scoped>
.proBox{
	width: 100%;
	max-width: 1400px;
	height: auto;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-around;
	margin: 20px auto;
	border-radius: 15px;
}
.serviceT{
	font-size: 24px;
	font-weight: 800;
}
.li-w{
	display: flex;
	flex-wrap: wrap;
}
.li-w>li{
	min-width: 50%;
	font-size: 24px;
	line-height: 200%;
}
li::marker{
	color: #4264b5;
	font-size: 2rem;
}
</style>